export default {
  label: {
    dashboardSelectlabel: 'Dashboard',
    dashboardSelectPlaceholder: 'Select a dashboard',
    noTitleDashboard: 'Dashboard without title',
    isStagingTooltip: 'This research belongs to the test environment (staging)',
  },
};
